/* ------------------------------------------------------------------
   Aegis Guard - moteur d'animation pilote par le defilement.

   Tout element portant data-ag-sp, data-ag-reveal ou data-ag-count
   recoit une progression p comprise entre 0 et 1, ecrite dans la
   propriete personnalisee --ag-p et recalculee a chaque image.

     p = 0  quand le haut de l'element est a 100 px sous le bas de l'ecran
     p = 1  quand il est remonte aux deux tiers de la hauteur de l'ecran

   L'element revient en arriere si l'on remonte : la valeur est
   recalculee, jamais memorisee.

   Fin de page : un element qui ne peut plus remonter jusqu'aux deux
   tiers, faute de defilement restant, voit son trajet comprime sur le
   defilement qui reste, de facon a atteindre 1 en bas de page. Sans
   cela les derniers elements resteraient a moitie transparents.

   Pas de scroll-timeline CSS (support inegal) : requestAnimationFrame
   et getBoundingClientRect, donc identique sur Safari iOS.

   prefers-reduced-motion : p vaut 1 en permanence, etat final direct.
   ------------------------------------------------------------------ */
(function () {
  var W = window;
  var D = document;

  if (W.__agScrollEngine) return;
  W.__agScrollEngine = true;

  /* Les sections Aegis testent ce drapeau avant d'installer leur ancien
     observateur de revelation. Il est deja pose par le script inline du
     layout ; on le repose ici par securite.
     __ag90Seq (compteurs et barre de la section 90 jours), __agStack
     (boucle des cartes d'avis de la section prix) et __agAcc (accordeon
     mobile) ne sont pas touches : ces trois animations restent au temps. */
  W.__agReveal = true;

  D.documentElement.classList.add('ag-scroll-on');

  var reduce = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
  var items = [];
  var ticking = false;

  function countParts(raw) {
    var m = (raw || '').match(/^([0-9]+)(.*)$/);
    return m ? { target: parseInt(m[1], 10), suffix: m[2] } : null;
  }

  /* Une section qui porte data-ag-scroll-off garde ses propres
     animations au temps : le moteur ignore tout ce qu'elle contient. */
  function excluded(el) {
    if (el.closest) return !!el.closest('[data-ag-scroll-off]');
    var n = el;
    while (n && n.nodeType === 1) {
      if (n.hasAttribute && n.hasAttribute('data-ag-scroll-off')) return true;
      n = n.parentNode;
    }
    return false;
  }

  function collect() {
    items = [];
    var nodes = D.querySelectorAll('[data-ag-sp], [data-ag-reveal], [data-ag-count]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (excluded(el)) continue;
      items.push({
        el: el,
        last: -1,
        count: el.hasAttribute('data-ag-count') ? countParts(el.getAttribute('data-ag-count')) : null
      });
    }
  }

  /* Le theme Horizon fait defiler .page-wrapper au-dela de 990 px de
     large, et la fenetre en dessous. On retrouve le bon conteneur pour
     savoir combien de defilement il reste. */
  function scrollerEl() {
    var w = D.querySelector('.page-wrapper');
    if (w && w.scrollHeight - w.clientHeight > 8) return w;
    return D.scrollingElement || D.documentElement;
  }

  function update() {
    ticking = false;
    if (!items.length) return;

    var vh = W.innerHeight || D.documentElement.clientHeight;
    var start = vh + 100;
    var end = (vh * 2) / 3;
    var sc = scrollerEl();
    var rest = sc.scrollHeight - sc.clientHeight - sc.scrollTop;
    if (!(rest > 0)) rest = 0;

    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var p = 1;

      if (!reduce) {
        var top = it.el.getBoundingClientRect().top;
        var gone = start - top;
        if (gone <= 0) {
          p = 0;
        } else {
          var span = start - end;
          if (top - end > rest) span = gone + rest;
          p = span > 0 ? gone / span : 1;
          if (p < 0) p = 0;
          if (p > 1) p = 1;
        }
      }

      var r = Math.round(p * 1000) / 1000;
      if (r === it.last) continue;
      it.last = r;
      it.el.style.setProperty('--ag-p', r);
      if (it.count) {
        it.el.textContent = Math.round(it.count.target * r) + it.count.suffix;
      }
    }
  }

  function request() {
    if (ticking) return;
    ticking = true;
    W.requestAnimationFrame(update);
  }

  function boot() {
    collect();
    update();
  }

  /* Le menu principal (overflow-list) mesure sa largeur une seule fois,
     avant que la feuille de style de marque et la police Inter ne soient
     prises en compte : il repliait « Contact » sous un bouton « Plus »
     alors que les cinq entrees tiennent. On lui fait recalculer une fois
     tout charge, en variant d'un pixel la largeur de son conteneur —
     c'est ce que son observateur de redimensionnement attend. */
  function nudgeMenus() {
    var lists = D.querySelectorAll('overflow-list');
    for (var i = 0; i < lists.length; i++) {
      var host = lists[i].parentElement;
      if (!host || host.agNudging) continue;
      var w = host.getBoundingClientRect().width;
      if (!w) continue;
      /* La largeur d'origine n'est memorisee qu'une fois : deux appels
         rapproches ne doivent pas se marcher dessus et laisser une
         largeur figee en style inline. */
      if (host.agWidth0 === undefined) host.agWidth0 = host.style.width;
      host.agNudging = true;
      (function (h) {
        h.style.width = Math.round(w + 1) + 'px';
        W.setTimeout(function () {
          h.style.width = h.agWidth0;
          h.agNudging = false;
        }, 220);
      })(host);
    }
  }

  if (D.readyState === 'loading') {
    D.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  try {
    D.addEventListener('scroll', request, { capture: true, passive: true });
  } catch (e) {
    D.addEventListener('scroll', request, true);
  }
  W.addEventListener('resize', request);
  W.addEventListener('orientationchange', request);
  W.addEventListener('load', function () { boot(); nudgeMenus(); });
  if (D.fonts && D.fonts.ready && D.fonts.ready.then) { D.fonts.ready.then(nudgeMenus); }
  D.addEventListener('shopify:section:load', function () { boot(); nudgeMenus(); });
})();